import { filters } from "@astrocentro-webapp/ui/config/filters";

export class FormatFiltersHelper {
  static perform(query = "", to = "api") {
    let formatted = query;

    for (const [key, filter] of Object.entries(filters[to])) {
      formatted = formatted.replaceAll(key, filter.name);

      for (const [key, filterValue] of Object.entries(filter.values)) {
        formatted = formatted.replaceAll(key, filterValue);
      }
    }

    return formatted;
  }
}
